// initialize bugsnag ASAP, before other imports
import bugsnag from "bugsnag-js";
import React from "react";
import { Provider } from "react-redux";
import { UncontrolledAlert } from "reactstrap";
import createPlugin from "bugsnag-react";
import configureStore from "./store/configure_store";
import App from "./components/app";

// const bugsnagClient = bugsnag({
//   apiKey: process.env.BUGSNAG_API_KEY,
//   releaseStage: process.env.NODE_ENV
// });
const store = configureStore();
// const ErrorBoundary = bugsnagClient.use(createPlugin(React));
const FallbackComponent = () => (
  <div className='container mt-4 text-center'>
    <UncontrolledAlert color='warning'>
      申し訳ありません、予期しないエラーが発生しました、お手数ですが、再度ページを読み込んで下さい。
    </UncontrolledAlert>
  </div>
);

function index(props) {
  return (
    // <ErrorBoundary FallbackComponent={FallbackComponent}>
      <Provider store={store}>
        <App {...props} />
      </Provider>
    // </ErrorBoundary>
  );
}

export default index;
